<template lang="pug">
  //
    Everything is wrapped in a label, which acts as a clickable wrapper around a form element.
    In this case, the file input.
  div
    label.file-select
      // We can't use a normal button element here, as it would become the target of the label.
      PTextField(
        :label="label"
        name="file"
        v-model="fileName"
        :error="error"
        readonly
        @click="clickedTextField"
        @keydown.enter="clickedTextField"
      )

      .button(v-if="!multiple || !existemArquivosAnexados")
        PButton(color="primary", size="sm", tabindex="0", @keydown.enter="clickedButton", ref="button" @click="clickedButton")
          .icon-bv-icones-clip.fs-19

      .button(v-else)
        PButton(color="primary", size="sm", tabindex="0", @keydown.enter="editarArquivos", ref="button" @click="editarArquivos")
          .icon-ptt-icons-lapis.fs-19

      // Now, the file input that we hide.
      input(type='file' :accept="accept" @change='handleFileChange' ref="input" :multiple="multiple")

</template>

<script>
import Storage from '@aws-amplify/storage'
import { AWS } from '@aws-amplify/core'

export default {
  props: {
    value: File,
    required: { 'default': false },
    error: String,
    label: { type: String, required: true },
    allowedTypes: {
      type: Array,
      'default': function () {
        return ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg', 'application/pdf']
      }
    },
    accept: {type: String, default: ''},
    multiple: {type: Boolean, default: false},
    onlyButtonOpenNewFile: {type: Boolean, default: false}
  },
  data () {
    return {
      file: null,
      arquivos: [],
      creds: {
        'access_key': 'AKIAJWRKLK5QB3KXHEWQ',
        'secret_key': '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'
      }
    }
  },
  computed: {
    invalid () {
      return !this.file && this.required
    },
    existemArquivosAnexados () {
      return this.arquivos && this.arquivos.length > 0
    },
    fileName () {
      if (this.multiple) {
        return this.existemArquivosAnexados
          ? `${this.arquivos.length} arquivo(s) anexados`
          : ''
      }

      return this.value ? this.value.name : ''
    }
  },
  methods: {
    clickedButton () {
      this.$refs.input.click()
    },
    clickedTextField () {
      if (this.onlyButtonOpenNewFile) return
      this.clickedButton()
    },
    editarArquivos () {
      this.$emit('editarArquivos')
    },
    focus () {
      this.$refs.button.focus()
    },
    handleFileChange (e) {
      this.file = e.target.files[0]
      this.$emit('input', this.file)

      if (this.multiple) {
        this.arquivos = e.target.files
        this.$emit('atualizarMultiplosArquivos', this.arquivos)
      }
    },
    atualizaArquivos (novaListaDeArquivos) {
      this.arquivos = novaListaDeArquivos
    },
    async uploadToStorage (bucket, fileName = null) {
      if (!this.allowedTypes.find(i => i === this.file.type)) {
        throw new Error('invalid type')
      }

      fileName = fileName || this.file.name
      const result = await this.$API.uploadFile(bucket, this.file, fileName)
      return result
    },
    upload (bucket, fileName = null) {
      if (!this.allowedTypes.find(i => i === this.file.type)) {
        throw new Error('inválid type')
      }

      fileName = fileName || this.file.name

      AWS.config.update({
        credentials: new AWS.Credentials({
          accessKeyId: this.creds.access_key,
          secretAccessKey: this.creds.secret_key
        })
      })

      Storage.configure({
        AWSS3: {
          region: 'us-west-2',
          bucket
        }
      })
      return new Promise((resolve, reject) => {
        Storage.put(
          fileName,
          this.file,
          {contentType: this.file.type, customPrefix: {public: ''}}
        )
          .then(() => {
            resolve(`https://s3-sa-east-1.amazonaws.com/${bucket}/${fileName}`)
          })
          .catch(reject)
      })
    }
  }
}
</script>

<style scoped>
.file-select {
  display: grid;
  grid-template-columns: 1fr .1fr;
  align-items: end;
}
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2EA169;

  border-radius: .3rem;

  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > .button-input-file {
  display: inline;
  padding: 10px 10px;
}
.file-select > .input-file-name {
  display: block;
  width: 110%;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  align-self: end;
  height: 38px;
}
.file-select > .input-file-name {
  display: inline;
}
.file-select > input[type="file"] {
  width: 19%;
  display: none;
}
.input-file-invalid {
  border-color: red !important;
}

.button {
  margin-bottom: 7px;
}
</style>
